import React, { useEffect, useState } from "react";
import BannerForm from "../Layout/BannerForm";
import { BannerFormValues } from "src/models/Banner.model";
import { object, string, mixed, array } from "yup";
import { Form, Formik, FormikHelpers } from "formik";
import { Dialog } from "@mui/material";
import {
  useGetCMSByTypeQuery,
  useUpdateCMSMutation,
} from "src/services/CMSService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const EditBannerFormWrapper = ({ onClose }: Props) => {
  const [items, setItems] = useState<any>({});
  const {
    data,
    isLoading,
    isFetching,
  }: // refetch,
  any = useGetCMSByTypeQuery("BANNER");
  const [updateBannerById] = useUpdateCMSMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: BannerFormValues = {
    content: items?.length
      ? items.map((c: any) => ({
          name: c.name || "",
          image: c.image || "",
        }))
      : [
          {
            name: "",
            image: "",
          },
        ],
  };

  const validationSchema = object().shape({
    content: array().of(
      object().shape({
        name: string().required("Please enter name"),
        image: mixed().required("Please upload image"),
      })
    ),
  });

  const handleSubmit = (
    values: BannerFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BannerFormValues>
  ) => {
    const payload = {
      content: values.content.map((c) => ({
        name: c.name,
        image: c?.image,
      })),
    };

    updateBannerById({ type: "BANNER", body: payload })
      .unwrap()
      .then((res) => {
        showToast("success", res?.data?.message);
        onClose();
        // refetch()
        setSubmitting(false);
        resetForm();
      })
      .catch((err) => {
        console.error("Failed to update Contact Info: ", err);
        showToast(
          "error",
          err?.data?.message ||
            "Failed to update Contact Info. Please try again."
        );
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <BannerForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBannerFormWrapper;
